<template>
  <transition name="scroll-top-fade">
    <v-btn
      v-show="show"
      fab
      fixed
      bottom
      right
      color="primary"
      class="scroll-top-btn"
      @click="scrollToTop"
      elevation="6"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </transition>
</template>

<script>
export default {
  name: 'ScrollTopButton',
  data () {
    return {
      show: false,
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      this.show = window.scrollY > 200
    },
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped lang="scss">
.scroll-top-btn {
  bottom: 32px !important;
  right: 32px !important;
  opacity: 0.92;
  transition: opacity 0.2s, transform 0.2s;
  z-index: 100;
  &:hover {
    opacity: 1;
    transform: translateY(-3px);
  }
}
.scroll-top-fade-enter-active,
.scroll-top-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.scroll-top-fade-enter,
.scroll-top-fade-leave-to {
  opacity: 0;
  transform: translateY(16px);
}
</style>
